import { Swarm } from "@lbs/swarm-client";

// Payload item expected by the get_bet_builder_odds swarm call.
export interface IBetBuilderOddsSelection {
  selectionId: number;
  homeValue: number;
  awayValue: number;
  selectionTypeId: number;
  marketId: number;
  selectionName: string;
  price: number;
}

// Swarm response shape (data.details) for get_bet_builder_odds.
export interface IBetBuilderOddsDetails {
  OddsPerMatch: { MatchId: number; Odd: number }[];
  RejectedIds: number[];
  TotalOdd: number;
}

/**
 * Validate a combination of bet builder selections and return per-match +
 * total odds. The server also returns RejectedIds — selection ids that could
 * not be combined with the rest and should be removed from the betslip.
 */
export const getBetBuilderOdds = async (
  selections: IBetBuilderOddsSelection[]
): Promise<IBetBuilderOddsDetails> => {
  const { data } = await Swarm.getInstance().getData<{ details?: IBetBuilderOddsDetails }>(
    { selections },
    "get_bet_builder_odds"
  );

  const details = data?.data?.details;

  if (!details) {
    throw new Error("Bet builder odds: empty response");
  }

  return {
    OddsPerMatch: details.OddsPerMatch || [],
    RejectedIds: details.RejectedIds || [],
    TotalOdd: details.TotalOdd ?? 0,
  };
};
